module.exports = __webpack_public_path__ + "static/media/cameraOff_filled_light.e9ceabd0.svg";